import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GrupoPermissao } from 'src/app/models/api/autenticacao/grupo-permissao.interface';
import { ApiGrupoPermissaoService } from 'src/app/services/api/autenticacao/api-grupo-permissao.service';
import { ApiFuncionarioService } from 'src/app/services/api/autenticacao/api-funcionario.service';
import { ToastType } from 'src/app/ui/toast/toast.model';
import { ToastService } from 'src/app/ui/toast/toast.service';

@Component({
  selector: 'c-employee-permissions-modal',
  templateUrl: './employee-permissions-modal.component.html',
  styleUrls: ['./employee-permissions-modal.component.scss']
})
export class EmployeePermissionsModalComponent implements OnInit {

  /** Injetados pelo ModalService via contentInitialState */
  readonly funcionarioId: string;
  readonly initialGruposPermissaoIdList: string[];
  /** Fecha o modal; atribuido pelo ComponentLoaderService */
  readonly destroy: () => void;

  permissionGroupData: GrupoPermissao[] = [];
  form: FormGroup;
  saving = false;

  constructor(
    private fb: FormBuilder,
    private apiGrupoPermissaoService: ApiGrupoPermissaoService,
    private apiFuncionarioService: ApiFuncionarioService,
    private toastService: ToastService,
  ) {
    this.form = this.fb.group({ gruposPermissaoIdList: [[]] });
  }

  ngOnInit() {
    this.form.patchValue({ gruposPermissaoIdList: this.initialGruposPermissaoIdList || [] });
    this.apiGrupoPermissaoService.get().subscribe(res => {
      this.permissionGroupData = res;
    });
  }

  async salvar() {
    this.saving = true;
    try {
      const message = await this.apiFuncionarioService
        .updatePermissoes(this.funcionarioId, this.form.value.gruposPermissaoIdList)
        .toPromise();
      this.toastService.toast(message || 'Permissões atualizadas com sucesso!', ToastType.success);
      this.destroy();
    } finally {
      this.saving = false;
    }
  }

  cancelar() {
    this.destroy();
  }

}
